import { v4 as _uuidv } from "uuid";
const uuidv4 = _uuidv;
export default (class Speaker {
  constructor(options) {
    this.id = uuidv4();
    this.name = options.name || "unknown";
    this.colour = options.colour || '#269C88';
  }
});